export default {
	SET_TEMPLATE(state, template) {
		state.template = template;
	},

	SET_TEMPLATES(state, templates) {
		state.templates = templates;
	},

	SET_CAMPAIGNS(state, campaigns) {
		state.campaigns = campaigns;
	},

	SET_CAMPAIGN(state, campaign) {
		state.campaign = campaign;
	},

	SET_FORMATS(state, formats) {
		state.formats = formats;
	},

	SET_FORMAT(state, format) {
		state.format = format;
	},

	SET_IMAGES(state, images) {
		state.images = images;
	},

	SET_CURRENT_IMAGE_INDEX(state, currentImageIndex) {
		state.currentImageIndex = currentImageIndex;
	}
};


// WEBPACK FOOTER //
// ./resources/assets/js/components/store/template-images/mutations.js